<!-- 左上角 -->
<template>
    <div class='bg box box_v' id="overview_card1">
        <div class="title1">生源住房情况统计</div>
        <div class="card1_box">
          <div class="card1listTitle">
            <div>序号</div><div>住房情况</div><div>幼升小</div><div>五升六</div><div>小升初</div>
          </div>
          <div v-for="(item,index) in list" :class="index%2!=0?'card1list card1listbg':'card1list'">
            <div><span>{{index+1}}</span></div>
            <div>自购商品房</div>
            <div>1190人</div>
            <div>1190人</div>
            <div>1190人</div>
          </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[{},{},{},{},{}],
        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {

    }, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftup.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:28px 0 0 40px
}
.card1_box{width: 100%;}
.card1listTitle{width: 100%;display: flex;display: -webkit-flex;height: 38px;align-items: center;font-size: 16px;color: #FFFFFF;margin-top: 18px;
background: linear-gradient(90deg, rgba(21, 144, 245, 0) 0%, #0067BC 48%, rgba(21, 144, 245, 0) 100%);
}
.card1listTitle div:nth-child(1){width:70px;text-align: center;}
.card1listTitle div:nth-child(2){width:156px;text-align: left;margin-left: 6px;}
.card1listTitle div:nth-child(3){width:76px;text-align: center;margin-left: 6px;}
.card1listTitle div:nth-child(4){width:76px;text-align: center;}
.card1listTitle div:nth-child(5){width:76px;text-align: center;}

.card1list{width: 100%;display: flex;display: -webkit-flex;height: 38px;align-items: center;font-size: 16px;color: #FFFFFF;}
.card1list div:nth-child(1){width:70px;display: flex;display: -webkit-flex;justify-content: center;align-items: center;}
.card1list div:nth-child(1) span{width: 22px;height: 18px;background: rgba(255, 255, 255, 0);border-radius: 6px;font-size: 12px;color: #FFF550;
font-weight: bold;display: flex;display: -webkit-flex;justify-content: center;align-items: center;
box-shadow: 0px 1px 2px 0px rgba(8, 1, 3, 0.35), 0px 3px 7px 0px rgba(149, 204, 255, 0.82);}
.card1list div:nth-child(2){width:156px;text-align: left;margin-left: 6px;font-size: 14px;}
.card1list div:nth-child(3){width:76px;text-align: center;margin-left: 6px;font-weight: normal;font-style: italic;
background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
-webkit-background-clip: text;-webkit-text-fill-color: transparent;}
.card1list div:nth-child(4){width:76px;text-align: center;font-weight: normal;font-style: italic;
background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
-webkit-background-clip: text;-webkit-text-fill-color: transparent;}
.card1list div:nth-child(5){width:76px;text-align: center;font-weight: normal;font-style: italic;
background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}
.card1listbg{background: linear-gradient(90deg, rgba(0, 252, 255, 0.2) 0%, rgba(0, 25, 36, 0.2) 100%);}



</style>
